import { render, staticRenderFns } from "./feeTable.vue?vue&type=template&id=2cc44217&scoped=true"
import script from "./feeTable.vue?vue&type=script&lang=js"
export * from "./feeTable.vue?vue&type=script&lang=js"
import style0 from "./feeTable.vue?vue&type=style&index=0&id=2cc44217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc44217",
  null
  
)

export default component.exports